import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { cfMetaLevel, _mlLicensingUserGroupPermission, durationPickerType, cfHeaderFieldType } from "redux/Types";
import UserDisplay from "util/UserDisplay";
import Moment from "react-moment";
import TextElement from "util/preview-element/TextElement";
import clsx from "clsx";
import { CircularProgress, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField, TextareaAutosize, Typography } from "@material-ui/core";
import { TextInput } from "util/input-elements/TextInput";
import { AsyncAutocomplete } from "util/async-autocomplete/AsyncAutocomplete";
import { AiFillFile, AiFillFolderAdd, AiOutlineCopy } from "react-icons/ai";
import { getCFContent } from "../../../redux/actions/MlLicFormContentActions";
import DatePickerDropdown from "util/input-elements/DatePickerDropdown";
import moment from "moment";
import { DatePicker, DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DateRangeSelector from "util/input-elements/DateRangeSelector";
import DurationPicker from "util/input-elements/DurationPicker";
import store from "redux/Store";
import { _PermittedContent } from "_module/utils/PermittedContent";
import GroupDisplay from "util/GroupDisplay";
import { FilterOperatorTypes, SortTypes } from "util/table-view/TableTypes";
import CfGroupQuestions from "./headerFieldUtils/CfGroupQuestions";
import DOMPurify from "dompurify";
import { getReadonlyFields } from "util/CommonFunc";
import { Autocomplete } from "@material-ui/lab";
import CfHqDelivery from "./headerFieldUtils/CfHqDelivery";

export default function HeaderFieldsDisplay({
  cf,
  editmode = false,
  gridColumns = 1,
  trimLabels = false,
  questionCharLenth = 30,
  answerCharLenth = 30,
  isPreviewPanel = false,
  classes,
  onChange,
  onSelectMasterForm,
  setHQtobeValidated,
  previewLevel = cfMetaLevel.ADVANCED,
  previewMetaDetails = true,
  copyCf,
  props
}) {

  const [selectedMasterFormLoading, setSelectedMasterFormLoading] = useState(false);
  const [selectedMasterForm, setSelectedMasterForm] = useState(null);
  const [validationFields, setValidationFields] = useState([]);
  const [hilightFields, setHilightFields] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);

  const { clearanceRuntime: { runtime } } = store.getState();
  const readOnlyHq = getReadonlyFields(runtime, cf) || [];
  const headerQs = getHeaderFields() || [];

  useEffect(() => {
    if (selectedMasterForm) {
      const { clearErrors } = props;

      async function fetchCF() {
        let resutls = await getCFContent(selectedMasterForm[0].id);
        resutls["selectedMasterForm"] = selectedMasterForm[0]
        // onValueChange("seriesTitle", resutls["seriesTitle"]);

        if (readOnlyHq.length) {
          readOnlyHq.forEach(rv => {
            onValueChange(rv, resutls[rv]);
          });
        }
        onValueChange("selectedMasterForm", selectedMasterForm[0]);
        onValueChange("selectedMasterFormId", selectedMasterForm[0]?.id);

        if (cf.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.SPORT) {
          onValueChange("masterTxDates", resutls?.txDates);
        }

        setSelectedMasterFormLoading(false);
        clearErrors();
        // copyCf(resutls);
      }
      fetchCF();
    }
  }, [selectedMasterFormLoading]);

  useEffect(() => {
    if (editmode && !compareArrays(headerQs, validationFields)) {
      setValidationFields(headerQs);
    }

    if (editmode) {
      const firstUnansweredIndex = headerQs?.findIndex((q, index) => {
        return (
          (!cf.hasOwnProperty(q.id)
            || !cf[q.id]
            || (Array.isArray(cf[q.id]) && cf[q.id].length === 0))// Check if question has been answered
          && (!readOnlyHq.includes(q?.id))
        );
      });

      if (firstUnansweredIndex !== -1) {
        if (activeIndex > firstUnansweredIndex) {
          if (headerQs.length === activeIndex) {
            setActiveIndex(firstUnansweredIndex);
          } else {
            setActiveIndex(activeIndex);
          }
        } else {
          setActiveIndex(firstUnansweredIndex);
        }
      }
      else {
        setActiveIndex(activeIndex);
      }

      if (headerQs.length > 0) {
        if (!editmode && previewLevel === cfMetaLevel.BASIC) {
          Object.keys(readOnlyHq).forEach(id => {
            readOnlyHq[id] = readOnlyHq[id].filter(q => q.level === cfMetaLevel.BASIC);
          });
        }
      }
    }

  }, [headerQs]);

  useEffect(() => {
    if (editmode && setHQtobeValidated) {
      setHQtobeValidated(validationFields);
    }
  }, [validationFields]);

  // Adding Created by, created At, Updated By, Updated At - to display on preview panels
  if (!editmode) {
    if (previewMetaDetails) {
      headerQs.push(
        {
          id: "createdAt",
          label: "Date Created",
          type: "dateTime"
        },
        {
          id: "createdBy",
          label: "Created By",
          type: "userDisplay"
        },
        {
          id: "updatedAt",
          label: "Date Update",
          type: "dateTime"
        },
        {
          id: "updatedBy",
          label: "Updated By",
          type: "userDisplay"
        }
      );
    }
  }

  const groupedHeaderQs = groupArrayByCount(headerQs, gridColumns) || [];

  function getHeaderFields() {
    let hQ = [];

    if (runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST) {
      runtime._config.CF_HEADER_FIELD_LIST.map(field => {
        return (field.visibleOn || field?.visibleOn?.length > 0)
          ?
          field.visibleOn.map(v => {
            if (v.operator && v.operator === "AND") {
              if (v.visibleCondition.map(c => cf[c.key] === c.value).every(k => k)) {
                hQ.push(field);
              }
            } else if (cf[v.key] === v.value) {
              hQ.push(field);
            }
          })
          :
          hQ.push(field);
      });

      if (!editmode && previewLevel === cfMetaLevel.BASIC) {
        hQ = hQ.filter(q => q.level === cfMetaLevel.BASIC);
      }
    }

    if (readOnlyHq.length > 0) {
      hQ.sort(sortByReadOnly);
    }

    return hQ;
  }

  // function getReadonlyFields() {
  //   let hQ = [];

  //   if (runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST) {
  //     runtime._config.CF_HEADER_FIELD_LIST.forEach(field => {
  //       if (field.readOnly && field.readOnly.length > 0) {
  //         field.readOnly.forEach(condition => {
  //           if (condition.readOnlyCondition.every(cond => cf[cond.key] === cond.value)) {
  //             hQ.push(field.id)
  //           }
  //         });
  //       }
  //     });
  //   }

  //   return hQ;
  // }

  function sortByReadOnly(a, b) {
    const aIndex = readOnlyHq.indexOf(a.id);
    const bIndex = readOnlyHq.indexOf(b.id);

    if ((aIndex !== -1 && bIndex !== -1) || (aIndex === -1 && bIndex === -1)) {
      return 0;
    } else if (aIndex !== -1) {
      return 1;
    } else {
      return -1;
    }
  }

  function compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = arr1.sort((a, b) => a.id - b.id);
    const sortedArr2 = arr2.sort((a, b) => a.id - b.id);

    for (let i = 0; i < sortedArr1.length; i++) {
      const obj1 = sortedArr1[i];
      const obj2 = sortedArr2[i];

      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }

      for (let key in obj1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
    }

    return true;
  }

  function groupArrayByCount(hqList, count) {
    const result = [];
    let group = [];
    const chunkCount = Math.ceil(hqList.length / count);

    hqList.forEach((item, index) => {
      group.push(item);

      if ((index + 1) % chunkCount === 0 || index === hqList.length - 1) {
        result.push(group);
        group = [];
      }
    });

    return result;
  }

  const renderAnswers = (field) => {
    switch (field.type) {
      case cfHeaderFieldType.HEADER_PROG_TYPE:
        return (field.options[field.options.findIndex(d => d.value === cf[field.id])]?.displayLabel || "");
      case "iconButtons":
      // case "headerClearanceType":
      case cfHeaderFieldType.OPTIONS:
      case cfHeaderFieldType.RADIO:
        let index = field.options.findIndex(d => d.value === cf[field.id])
        return (field.options[index]?.label || "");

      case cfHeaderFieldType.USER_DISPLAY:
        if (cf[runtime?._config?.MIGRATED_FLAG]) {
          return `${cf?.mlData?.createdByTitle} ${cf?.mlData?.createdByFirstName} ${cf?.mlData?.createdByLastName}`;
        }
        else {
          return (<UserDisplay userId={cf[field.id]} />);
        }

      case cfHeaderFieldType.GROUP_SEARCH:
        if (field?.options?.length > 0) {
          let index = field.options.findIndex(d => d.value === cf[field.id])
          return (field.options[index]?.label || "");
        }
        else {
          return (cf[field.id] ? <GroupDisplay groupId={[cf[field.id]]} /> : "");
        }

      case cfHeaderFieldType.DATE_TIME:
        if (cf[runtime?._config?.MIGRATED_FLAG]) {
          return (
            cf?.mlData[field.id] ? (
              <Moment
                format="DD/MM/YYYY h:mm:ss A"
                titleFormat="DD/MM/YYYY h:mm:ss A"
                withTitle
              >
                {cf?.mlData[field.id]}
              </Moment>
            ) : ''
          );
        }
        else {
          return (
            cf[field.id] ? (
              <Moment
                format="DD/MM/YYYY h:mm:ss A"
                titleFormat="DD/MM/YYYY h:mm:ss A"
                withTitle
              >
                {cf[field.id]}
              </Moment>
            ) : ''
          );
        }

      case cfHeaderFieldType.DATE:
      case cfHeaderFieldType.DATE_DROPDOWN:
        return (
          cf[field.id] ? (
            <Moment
              format="DD/MM/YYYY"
              titleFormat="DD/MM/YYYY"
              withTitle
            >
              {cf[field.id]}
            </Moment>
          ) : ''
        );

      case cfHeaderFieldType.DATE_RANGE:
        if (!cf[field.id]) { return (""); }
        const formattedDatesString = Array.isArray(cf[field.id]) ? cf[field.id]?.map(date => moment(date).format('DD/MM/YYYY')).join(' - ') : cf[field.id];

        return (
          formattedDatesString ? formattedDatesString : ""
        );

      case cfHeaderFieldType.DURATION:
      case cfHeaderFieldType.DURATION_DELIVERY:
        function getDurationValue(dType = durationPickerType.HHMMSS, value) {
          const seconds = value;
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          const remainingSeconds = seconds % 60;

          switch (dType) {
            case durationPickerType.SS:
              return `${remainingSeconds}`;
            case durationPickerType.MMSS:
              return `${minutes}:${remainingSeconds}`;
            case durationPickerType.HHMM:
              // return `${hours}:${minutes}`;
              return `${seconds / 60}`;
            case durationPickerType.HHMMSS:
            default:
              return `${hours}:${minutes}:${remainingSeconds}`;
          }
        }
        return (
          (field.type === cfHeaderFieldType.DURATION_DELIVERY
            ? <CfHqDelivery
              key={`${cf?.id}${field.id}`}
              field={field}
              cf={cf}
              onChangeLoading={(isLoading) => { }}
            />
            : cf[field.id] ? (`${getDurationValue(field.inputVariation, cf[field.id])} ${(field.inputVariation === durationPickerType.HHMMSS ? 'HH:mm:ss' : (field.inputVariation === durationPickerType.HHMM) ? 'HH:mm' : (field.inputVariation === durationPickerType.MMSS ? 'mm:ss' : 'ss'))}`) : '')
        );

      case cfHeaderFieldType.COMBINED_TEXT:
        let lReturn = "";
        if (cf[field.id] && field.subFields?.length > 0) {
          field.subFields.forEach((subField, index) => {
            lReturn += `${cf[field.id][subField.key]}${index < field.subFields.length - 1 ? " - " : ""}`;
          });
        }
        return lReturn;
      default:
        return (cf[field.id] ?? "");
    }
  }

  const getTrimmedLabel = (label, charLenth) => {
    if (label.length > charLenth) {
      return label.substring(0, charLenth - 3) + "...";
    }
    return label;
  }

  const onValueChange = (field, value, shouldReset = false, index = 0) => {
    if (headerQs.find(h => h.id === field)?.skipHighlight) {
      setActiveIndex(null);
    } else {
      if (readOnlyHq.length > 0 && headerQs[index + 1] && readOnlyHq.includes(headerQs[index + 1]?.id)) {
        setActiveIndex(null);
      } else {
        setActiveIndex(index + 1);
      }
    }
    onChange(field, value, shouldReset);
  }

  const getHeaderInputter = (field, index = 0, answered = false, isActive = false) => {
    const {
      classes,
      posting,
      clearErrors,
    } = props;

    let returnElement = null;

    switch (field.type) {
      case cfHeaderFieldType.GROUP_SEARCH:
        returnElement = ((cf?.id && field.id === "clearanceFormType") ? null :
          <CfGroupQuestions
            key={field.id === "clearanceFormType" ? field.id : `${field.id}${cf["clearanceFormType"]}`}
            field={field}
            cf={cf}
            createOrEdit={cf.id ? 'edit' : 'create'}
            props={props}
            classes={classes}
            posting={posting}
            onChange={(field, value, shouldRest) => { onValueChange(field, value, shouldRest, index) }}
            onChangeLoading={(isLoading) => {
              field.skipHighlight = isLoading;
              //added below to re-render the component after amending the value of "field.skipHighlight" as fix to the ML20-4087 (1 and 2nd issue)
              setHilightFields({
                ...hilightFields,
                [field.id]: isLoading
              })
            }}
            readOnlyList={readOnlyHq}
          />);
        break;

      case cfHeaderFieldType.HEADER_PROG_TYPE:
        returnElement = cf?.id ? null : getProgrammeTypeInputter(field);
        break;

      case "selfSearch":
        const {
          user: {
            credentials: { orgID }
          }
        } = props;

        let lookupQuery = {
          order: SortTypes.desc,
          orderBy: "updatedAt",
          page: 0,
          size: 10,
          q: "",
          filters: [],
        }
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>

              <div className={clsx(classes.clearanceSearchArea, classes.clearanceSearchAreaRemoveMargin)}>
                <AsyncAutocomplete
                  searchUri={`${orgID}/mllic/forms/lookup`}
                  lookupQuery={lookupQuery}
                  fieldNameForFilter={field.id}
                  page={0}
                  returnField={field.id}
                  returnAllFields={false}
                  emptyLabel={"No Suggestions"}
                  selected={[{ [field.id]: cf[field.id] }]}
                  onSelected={(selectedValue) => {
                    if (selectedValue && selectedValue.length > 0 && selectedValue[0][field.id]) {
                      onValueChange(
                        field.id,
                        selectedValue[0][field.id],
                        field.resetForm,
                        index
                      )
                    }
                  }}
                  // onInputChange={(event)=>{ onChange( field.id,  event ) }}
                  onInputChange={(event) => {
                    event = event.replace(/(^\s*)|(\s*$)/, "");
                    onValueChange(field.id, event, field.resetForm, index)
                  }}
                  classes={classes}
                />
                {posting.errors && posting.errors[field.id] && (
                  <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                    {posting.errors[field.id]}
                  </span>
                )}
              </div>

            </div>
          </>
        );
        break;

      case "iconButtons":
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>
              <div className={clsx(classes.questionLabels, "singleLabel")}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>

              {field.options.map((d, i) => {
                return (
                  <>
                    <div key={i} className={clsx(classes.activeHover, (d.value === cf[field.id] ? classes.activeRadio : ""))} style={{ backgroundColor: d.iconProp?.backgroundColor }}>
                      <input
                        type="radio"
                        name={field.id}
                        value={d.value}
                        onClick={(e) => onValueChange(
                          e.target.name,
                          e.target.value,
                          field.resetForm,
                          index
                        )}
                        checked={d.value === cf[field.id]}
                        id={`${field.id}${i}`}
                        class="input-hidden" />
                      <label htmlFor={`${field.id}${i}`}>
                        <img
                          src={d.iconProp?.imgSrc}
                          alt={d.iconProp?.altText || d.label || "CF form type logo"} style={{ maxWidth: "150px" }} />
                        {d.label}
                      </label>
                    </div>
                  </>
                )
              })}
              {posting.errors && posting.errors[field.id] && (
                <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                  {posting.errors[field.id]}
                </span>
              )}
            </div>
          </>
        );
        break;

      case cfHeaderFieldType.OPTIONS:
        let options = [];

        if (field.options?.length > 0) {
          field.options.map(opt => {
            return (opt.enableFor || opt?.enableFor?.length > 0)
              ?
              opt.enableFor.map(v => {
                if (v.operator && v.operator === "AND") {
                  if (v.enableCondition.map(c => cf[c.key] === c.value).every(k => k)) {
                    options.push(opt);
                  }
                } else if (cf[v.key] === v.value) {
                  options.push(opt);
                }
              })
              :
              options.push(opt);
          });
        }

        if(options.length === 1 & !cf[field.id]){
            onValueChange(
              field.id,
              options[0].value,
              field.resetForm,
              index
            );
        }

        if(field.noDuplicates){
          options = options.filter((v, i, arr) => arr.findIndex(t => (t.value === v.value)) === i);
        }

        if(field.sortOptions){
          options = options.sort((a, b) => a.label.localeCompare(b.label));
        }

        let elementKey = (field.id === "channel" && cf['userGroup']) ? `${cf['userGroup']}${field.id}` : field.id;

        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <div>
                {readOnlyHq?.includes(field.id) ?
                  (cf[field.id] ? <div className={classes.nameTextField}> {options.find(o => o.value === cf[field.id])?.label} </div> : '')
                  :
                  (field.autocomplete ?
                    <Autocomplete
                      key={elementKey}
                      name={field.id}
                      disableClearable
                      getOptionSelected={(option, value) => option.value === value.value}
                      getOptionLabel={(option) => option.label}
                      options={options || []}
                      openText={field.label || ''}
                      noOptionsText={"Not Available"}
                      value={options.find(d => d.value === (cf[field.id] ?? field.defaultValue))}
                      disabled={(options.length === 1) || false}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                      onChange={(e, opt) => {
                        onValueChange(
                          field.id,
                          opt.value,
                          field.resetForm,
                          index
                        );
                      }}
                    /> :
                    <Select
                      name={field.id}
                      value={cf[field.id] || field.defaultValue || ''}
                      fullWidth
                      onChange={(e) => {
                        onValueChange(
                          e.target.name,
                          e.target.value,
                          field.resetForm,
                          index
                        );
                      }}
                      inputProps={{
                        id: `${field.id}`,
                        "aria-labelledby": `${field.id}`,
                        "aria-label": `${field.label}`,
                      }}
                      title={field.label}
                      variant="outlined"
                      disabled={(options.length === 1) || false}
                    >
                      {options.map((opt, i) => {
                        return (
                          <MenuItem
                            key={i}
                            value={opt.value}
                          // disabled={(field.filterOptionsFor && cf[field.filterOptionsFor] && opt.enableFor && opt.enableFor.indexOf(cf[field.filterOptionsFor]) === -1)? true : false || false}              
                          >
                            {opt.label}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  )
                }
                {posting.errors && posting.errors[field.id] && (
                  <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                    {posting.errors[field.id]}
                  </span>
                )}
              </div>
            </div>
          </>
        )
        break;

      case cfHeaderFieldType.RADIO:
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.formErrorRadio : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.asInnerText
                    ? renderLabel(field)
                    : field.label
                  }
                  {" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <div>
                {readOnlyHq?.includes(field.id) ?
                  (cf[field.id] ? <div className={classes.nameTextField}> {field.options.find(o => o.value === cf[field.id])?.label}</div> : '')
                  :
                  <RadioGroup
                    name={field.id}
                    value={cf[field.id]}
                    onChange={(e) => onValueChange(
                      e.target.name,
                      e.target.value,
                      field.resetForm,
                      index
                    )}
                  >
                    {field.options.map((d, i) => {
                      return (
                        <>
                          <FormControlLabel value={d.value} key={i} control={<Radio />} label={<label style={{ color: d.color }}>{d.label}</label>} />
                        </>
                      )
                    })}
                  </RadioGroup>
                }
                {posting.errors && posting.errors[field.id] && (
                  <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                    {posting.errors[field.id]}
                  </span>
                )}
              </div>
            </div>
          </>
        )
        break;

      case cfHeaderFieldType.DATE:
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.MuiError : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    name={field.id}
                    aria-label={field.label}
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    className={clsx(classes.tableFilterInput, classes.tableFilterDate, classes.inputBorder)}
                    value={cf[field.id] ? moment(cf[field.id], 'yyyy-MM-DD').toDate() : null}
                    onChange={(event) => {
                      if (event && moment(moment(event).toDate()).isValid()) {
                        onValueChange(
                          field.id,
                          moment(event).format('yyyy-MM-DD'),
                          field.resetForm,
                          index
                        );
                      }
                    }}
                    autoOk
                    inputProps={{
                      'aria-label': field.label
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "Open Calendar",
                    }}
                  // disabled={busy}
                  />
                </MuiPickersUtilsProvider>
                {posting.errors && posting.errors[field.id] && (
                  <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                    {posting.errors[field.id]}
                  </span>
                )}
              </div>
            </div>
          </>
        );
        break;

      case cfHeaderFieldType.DATE_TIME:
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.MuiError : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  name={field.id}
                  aria-label={field.label}
                  ampm={false}
                  variant="inline"
                  format="dd/MM/yyyy HH:mm"
                  margin="normal"
                  className={clsx(classes.tableFilterInput, classes.tableFilterDate, classes.inputBorder)}
                  value={cf[field.id] ? moment(cf[field.id], 'yyyy-MM-DD HH:mm').toDate() : null}
                  onChange={(event) => {
                    onValueChange(
                      field.id,
                      event ? moment(event).format('yyyy-MM-DD HH:mm') : "",
                      field.resetForm,
                      index
                    );
                  }}
                  autoOk
                  inputProps={{
                    'aria-label': field.label
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "Open date picker",
                  }}
                // disabled={busy}
                />
              </MuiPickersUtilsProvider>
              {posting.errors && posting.errors[field.id] && (
                <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                  {posting.errors[field.id]}
                </span>
              )}
            </div>
          </>
        );

        break;

      case cfHeaderFieldType.DATE_DROPDOWN:
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.MuiError : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <DatePickerDropdown
                key={field.id}
                dateSelected={cf[field.id]}
                classes={classes}
                onChange={(selectedDate) => {
                  onValueChange(
                    field.id,
                    selectedDate ? selectedDate : "",
                    field.resetForm,
                    index
                  );
                }}
              />
              {posting.errors && posting.errors[field.id] && (
                <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                  {posting.errors[field.id]}
                </span>
              )}
            </div>
          </>
        );
        break;

      case cfHeaderFieldType.DATE_RANGE:
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.MuiError : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && (!cf[field.id] || !Array.isArray(cf[field.id]) || !cf[field.id].length)) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <div className={classes.dateRangeContainer}>
                <DateRangeSelector
                  key={field.id}
                  selectedRange={cf[field.id] || []}
                  classes={classes}
                  onChange={(range) => {
                    onValueChange(
                      field.id,
                      range,
                      field.resetForm,
                      index
                    )
                  }}
                />
                {posting.errors && posting.errors[field.id] && (
                  <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                    {posting.errors[field.id]}
                  </span>
                )}
              </div>
            </div>
          </>
        );

        break;

      case cfHeaderFieldType.DURATION:
      case cfHeaderFieldType.DURATION_DELIVERY:
        returnElement = (
          <>
            <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.MuiError : ""}`}>
              <div className={classes.questionLabels}>
                <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                  {field.label}{" "}
                  {field.required && <span className={classes.reqSymbol}>*</span>}
                </label>
                <span>:</span>
              </div>
              <div className={classes.durationcontainer}>
                {cf?.id && cf?.programmeType === runtime?._config?.PROGRAMME_TYPES.SERIES && field.type === "duration_delivery" &&
                  <div className={classes.episodeCount}>
                    <label>
                      Episode Count </label>
                    <div className={"countResult"}>
                      <CfHqDelivery
                        key={`${cf?.id}${field.id}`}
                        field={field}
                        cf={cf}
                        countOnly
                        onChangeLoading={(isLoading) => { }}
                      />
                    </div>

                  </div>
                }
                <div className={classes.durationcontainer}>
                  {!cf?.id && cf?.programmeType === runtime?._config?.PROGRAMME_TYPES.SERIES && field.type === "duration_delivery" &&
                    <div className={classes.episodeCount}> <label>
                      Episode Count </label>
                      <TextInput
                        name={'episodeCount'}
                        type="number"
                        classes={classes}
                        handleChange={(e) =>
                          onValueChange(
                            e.target.name,
                            e.target.value,
                            field.resetForm,
                            index
                          )
                        }
                        value={cf['episodeCount']}
                        errors={posting.errors || {}}
                        inputProps={{
                          "aria-label": `${'episodeCount'}`,
                          inputProps: {
                            min: 0
                          }
                        }}
                        onKeyDownEvent={(event) => {
                          if (posting?.errors && posting?.errors['episodeCount']) {
                            clearErrors('episodeCount');
                          }
                        }}
                      />

                    </div>
                  }
                  <DurationPicker
                    value={cf[field.id]}
                    classes={classes}
                    type={field.inputVariation ?? durationPickerType.MMSS}
                    onChange={(selectedDuration) => {
                      onValueChange(
                        field.id,
                        selectedDuration ? selectedDuration : "",
                        field.resetForm,
                        index
                      );
                    }}
                  />
                </div>
              </div>

              {posting.errors && posting.errors[field.id] && (
                <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                  {posting.errors[field.id]}
                </span>
              )}
            </div>
          </>
        );

        break;

      case cfHeaderFieldType.LARGE_TEXT:
        returnElement = (
          <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? classes.MuiError : ""}`}>
            <div className={classes.questionLabels}>
              <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                {field.label}{" "}
                {field.required && <span className={classes.reqSymbol}>*</span>}
              </label>
              <span>:</span>
            </div>
            <div className={classes.nameTextField}>
              <div>
                {readOnlyHq?.includes(field.id)
                  ? (cf[field.id] ?? '')
                  : <TextareaAutosize
                    minRows={2}
                    rows={2}
                    name={field.id}
                    className={clsx(classes.tableFilterInput, classes.root)}
                    aria-label={`${field.id}`}
                    value={cf[field.id]}
                    onChange={(e) =>
                      onValueChange(
                        e.target.name,
                        e.target.value,
                        field.resetForm,
                        index
                      )
                    }
                    onKeyDown={(event) => {
                      if (posting?.errors && posting?.errors[field.id]) {
                        clearErrors(field.id);
                      }
                    }}
                    helperText={(posting.errors && posting.errors[field.id]) || ""}
                    error={posting.errors && posting.errors[field.id] ? true : false}
                  />
                }
                {posting.errors && posting.errors[field.id] && (
                  <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                    {posting.errors[field.id]}
                  </span>
                )}
              </div>
            </div>
          </div>
        );

        break;

      case cfHeaderFieldType.NUMBER:
        returnElement = (
          <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>
            <div className={classes.questionLabels}>
              <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                {field.label}{" "}
                {field.required && <span className={classes.reqSymbol}>*</span>}
              </label>
              <span>:</span>
            </div>
            <div className={classes.nameTextField}>
              {readOnlyHq?.includes(field.id)
                ? (cf[field.id] ?? '')
                : <TextInput
                  name={field.id}
                  type="number"
                  classes={classes}
                  handleChange={(e) =>{
                    onValueChange(
                      e.target.name,
                      parseFloat(e.target.value),
                      field.resetForm,
                      index
                    )
                  }
                  }
                  value={parseFloat(cf[field.id]) ?? ""}  
                  errors={posting.errors || {}}
                  // selectOnFocus={true}
                  inputProps={{
                    "aria-label": `${field.id}`,
                    "inputProps": {
                      "min": field.min ? field.min : 0, // Ensure min is set to 0 if not defined
                    }
                  }}
                  onKeyDownEvent={(event) => {
                    if (posting?.errors && posting?.errors[field.id]) {
                      clearErrors(field.id);
                    }
                  }}
                />
              }
            </div>
          </div>
        );
        break;

      case cfHeaderFieldType.LABEL:
        returnElement = (
          <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>
            <div className={classes.questionLabels}>
              <Typography variant={field.variant ?? "subtitle1"} gutterBottom>
                {field.label}{" "}
              </Typography>
            </div>
          </div>
        );
        break;

      case cfHeaderFieldType.COMBINED_TEXT:
        let combinedLabel = "";
        if (field.subFields?.length > 0) {
          field.subFields.forEach((subField, index) => {
            combinedLabel += `${subField.label}${index < field.subFields.length - 1 ? " - " : ""}`;
          });
        }
        returnElement = (
          <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>

            <div className={classes.questionLabels}>
              <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                {combinedLabel}{" "}
                {field.required && <span className={classes.reqSymbol}>*</span>}
              </label>
              <span>:</span>
            </div>
            <div className={classes.combinedTextField}>
            {(field.subFields?.length ? field.subFields.map((subField, i) => {
              return (
                <>                
                  <div className={clsx(classes.nameTextField,"textFields")}>
                    {readOnlyHq?.includes(field.id)
                      ? (cf[field.id] ?? '')
                      : <div>
                          <span className={classes.inputLabel}>{subField.label}</span>
                          <TextInput
                            name={subField.key}
                            key={`${field.id}${subField.key}`}
                            type="text"
                            classes={classes}
                            handleChange={(e) =>
                              onValueChange(
                                field.id,
                                { ...cf[field.id], [subField.key]: e.target.value },
                                field.resetForm,
                                index
                              )
                            }
                            value={cf[field.id]?.[subField.key] ?? ""}
                            errors={(posting.errors ? (posting.errors[field.id] ?? {}) : {}) || {}}
                            inputProps={{
                              "aria-label": `${field.id}`,
                            }}
                            onKeyDownEvent={(event) => {
                              if (posting?.errors && posting?.errors[field.id]) {
                                clearErrors(field.id);
                              }
                            }}
                          />
                      </div>
                    }
                  </div>                 
                </>
              )
            }) : '')}
             </div>
          </div>
        );
        break;
        
      case cfHeaderFieldType.TEXT:
      default:
        const { checkUniqueValue } = props;
        returnElement = (
          <div className={`${classes.questionGroup} ${posting.errors && posting.errors[field.id] ? "Mui-error" : ""}`}>
            <div className={classes.questionLabels}>
              <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "", "requiredField")} style={field.subField ? { paddingLeft: "25px" } : {}}>
                {field.label}{" "}
                {field.required && <span className={classes.reqSymbol}>*</span>}
              </label>
              <span>:</span>
            </div>
            <div className={classes.nameTextField}>
              {readOnlyHq?.includes(field.id)
                ? (cf[field.id] ?? '')
                : <TextInput
                  name={field.id}
                  type="text"
                  classes={classes}
                  handleChange={(e) =>
                    onValueChange(
                      e.target.name,
                      e.target.value,
                      field.resetForm,
                      index
                    )
                  }
                  value={cf[field.id] || ""}
                  errors={posting.errors || {}}
                  // selectOnFocus={true}
                  inputProps={{
                    "aria-label": `${field.id}`,
                  }}
                  onKeyDownEvent={(event) => {
                    if (posting?.errors && posting?.errors[field.id]) {
                      clearErrors(field.id);
                    }
                  }}
                  onBlurEvent={(event) => {
                    if (field.uniqueValue && cf[field.id]) {
                      checkUniqueValue(field, cf[field.id], cf.id ? cf.id : "");
                    }
                  }}
                />
              }
            </div>
          </div>
        );
        break;
    }

    return (
      <div className={((index === activeIndex || isActive) && !field?.skipHighlight) ? classes.nextQuestionHilight : ''}>
        {returnElement}
      </div>
    );
  }

  const getLookupQuery = () => {
    const {
      cfForms: { masterLookupQuery },
    } = props;

    let query = { ...masterLookupQuery };

    query['filters'] = [...query.filters, { operator: FilterOperatorTypes.equals, value: [cf.clearanceFormType], field: "clearanceFormType" }]

    return query;
  }

  const getProgrammeTypeInputter = (field) => {

    const {
      user: {
        credentials: { orgID },
      },
      classes,
      posting,
      cfForms: { masterLookupQuery },
    } = props;

    let newMasterLookupQuery = {
      ...masterLookupQuery,
      filters: [
        ...masterLookupQuery.filters,
        { operator: FilterOperatorTypes.equals, value: [cf.clearanceFormType], field: "clearanceFormType" }
      ]
    }
    return (
      <div className={clsx(classes.noPaddindMargin)}>
        <div>
          <label>
            {field.label}{" "}
            {field.required && <span className={classes.reqSymbol}>*</span>}
          </label>
          <div className={classes.mainQuestions}>
            <RadioGroup
              value={cf.programmeType}
              onChange={(e) => handleProgrammeTypeChange(e, field.resetForm)}
            >
              {runtime && runtime._config && runtime._config?.PROGRAMME_TYPES_LIST?.filter(d => !d.hideInput).map((d, i) => {
                return (
                  <span key={i} className={clsx((d.value === cf[field.id] ? classes.activeRadio2 : ""), classes[d.StyleClass], cf.programmeType === d.value ? classes.ClassName : "")}   >
                    <FormControlLabel value={d.value} key={i} control={
                      <Radio icon={
                        d.value === runtime._config.PROGRAMME_TYPES.SERIES ?
                          <AiFillFile />
                          : d.value === runtime._config.PROGRAMME_TYPES.ONEOFF ?
                            <AiFillFolderAdd />
                            :
                            <AiOutlineCopy />
                      }
                        checkedIcon={
                          d.value === runtime._config.PROGRAMME_TYPES.SERIES ?
                            <AiFillFile />
                            : d.value === runtime._config.PROGRAMME_TYPES.ONEOFF ?
                              <AiFillFolderAdd />
                              :
                              <AiOutlineCopy />
                        }
                      />
                    } label={d.label} />
                  </span>
                )
              })}
            </RadioGroup>
          </div>
        </div>
        {runtime && runtime._config && cf.programmeType === runtime._config?.PROGRAMME_TYPES?.EPISODE && (
          <Grid container >
            <Grid item xs={6}>
              <div className={classes.clearanceSearchArea}>
                <AsyncAutocomplete
                  searchUri={`${orgID}/mllic/forms/lookup`}
                  lookupQuery={newMasterLookupQuery}
                  fieldNameForFilter={"seriesTitle"}
                  page={0}
                  returnField={'name'}
                  returnAllFields={false}
                  placeholder={"Search clearance form"}
                  onSelected={(selectedMasterForm) => {
                    if (selectedMasterForm && selectedMasterForm.length > 0 && selectedMasterForm[0]?.id) {
                      setSelectedMasterFormLoading(true);
                      setSelectedMasterForm(selectedMasterForm);
                      onSelectMasterForm();
                    }
                  }}
                />
                {selectedMasterFormLoading && (
                  <><span className={classes.loadingMasterTxt}><CircularProgress className={classes.insideLoader} /><span class="clearanceLoading">Loading master form</span></span></>
                )}
              </div>
            </Grid>
          </Grid>

        )}
        {posting.errors && posting.errors.programmeType && (
          <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
            {posting.errors.programmeType}
          </span>
        )}
      </div>
    );
  }

  const handleProgrammeTypeChange = (event, shouldReset = false) => {
    let master = false;
    if (runtime && runtime._config && event.target.value === runtime._config.PROGRAMME_TYPES?.SERIES) {
      master = true;
    }
    onValueChange("programmeType", event.target.value, shouldReset, 1);
    onValueChange("master", master, false, 1);
  }

  const renderLabel = (field) => {

    const convertedTxt = (txt) => {
      let text = txt.replace(/<b>/g, "<strong>").replace(/<\/b>/g, "</strong>")
      return DOMPurify.sanitize(text);
    }

    return (
      <span>{field.label.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          <span dangerouslySetInnerHTML={{ __html: convertedTxt(line) }}></span>
          {((field.label.split('\n').length - 1) !== index) && <br />}
        </React.Fragment>
      ))}
      </span>
    );
  }

  return (
    <>
      {groupedHeaderQs.length > 0 &&
        <>
          <Grid container key={`CfHqContainer`}>
            {groupedHeaderQs.map((ghq, index) => {
              return (
                <Grid item xs key={`CfHq${editmode ? 'Edt' : 'Prv'}${index}`}>
                  {ghq.map((q, i) => {
                    return (
                      editmode
                        ? // EDIT Header Fields
                        getHeaderInputter(q, i, (cf[q.id] !== null && cf[q.id] !== undefined && cf[q.id] !== ''), index === activeIndex)
                        : // PREVIEW Header Field Values
                        <>
                          <div className={clsx(classes.clearanceFormHeaderDetails, "formPopup")} key={`CfHqPreview${index}-${i}`}>
                            {isPreviewPanel
                              ?
                              (q.type !== "label") &&
                              <TextElement
                                label={trimLabels ? getTrimmedLabel(q.displayLabel ? q.displayLabel : q.label, questionCharLenth) : q.displayLabel ? q.displayLabel : q.label}
                                customLabelTitle={q.displayLabel ? q.displayLabel : q.label}
                                classes={classes}
                                data={renderAnswers(q) || ""}
                              />
                              :
                              <>
                                {/* {q.type === "label"
                                  ? <Typography variant={q.variant ?? "subtitle1"} gutterBottom>
                                    {q.label}{" "}
                                  </Typography>
                                  :<span title={q.displayLabel ? q.displayLabel : q.label || ""} style={q.subField ? {paddingLeft: "15px"} : {}} class="titleSpan formLabel">{trimLabels ? getTrimmedLabel(q.displayLabel ? q.displayLabel : q.label, questionCharLenth) : q.displayLabel ? q.displayLabel : q.label}</span>
                                } */}
                                <span title={q.displayLabel ? q.displayLabel : q.label || ""} style={q.subField ? { paddingLeft: "15px" } : {}} class="titleSpan formLabel">{trimLabels ? getTrimmedLabel(q.displayLabel ? q.displayLabel : q.label, questionCharLenth) : q.displayLabel ? q.displayLabel : q.label}</span>
                                {q.type !== "label" && <>
                                  :{" "}
                                  <span class="formValue" title={renderAnswers(q) || ""}> {trimLabels ? getTrimmedLabel(renderAnswers(q), answerCharLenth) : renderAnswers(q) || ""}</span>
                                </>}
                              </>
                            }
                          </div>
                        </>
                    )
                  })}
                  {cf[runtime?._config?.MIGRATED_FLAG] &&
                    previewLevel == cfMetaLevel.ADVANCED &&
                    <>
                      <>
                        {// Displaying static header questions 
                          cf.skyHeaderQuestions.filter(d => groupedHeaderQs.reduce((acc, curr) => {
                            curr.map(q => {
                              acc.push(q.label)
                            })
                            return acc;
                          }, []).indexOf(d.question) == -1).map((d, i) => {
                            return (
                              <>
                                <>
                                  <div className={clsx(classes.clearanceFormHeaderDetails, "formPopup")} key={`CfHqPreview-${i}`}>
                                    {isPreviewPanel
                                      ?
                                      <TextElement
                                        label={d.question}
                                        customLabelTitle={d.question}
                                        classes={classes}
                                        data={d?.answer}
                                      />
                                      :
                                      <>
                                        <span title={d.question} class="titleSpan formLabel">{d.question}</span>
                                        {<>
                                          :{" "}
                                          <span class="formValue" title={d?.answer || ""}> {d?.answer}</span>
                                        </>
                                        }
                                      </>
                                    }
                                  </div>
                                </>
                              </>
                            )
                          })
                        }
                      </>
                    </>
                  }
                </Grid>
              )
            })}
          </Grid>
        </>
      }
    </>
  );
}
